import { format } from "@formkit/tempo";
import clientHttp from "../tools/clientHttp";
import UserProfile from "../data";
const user = UserProfile.getUserData();
const URL = "/inventories";
const URL_STOCK_BY_PRODUCT = "/inventories/stock-by-product";
const URL_MOVEMENT_INVENTORY = "/inventories/transfer-bulk";
const URL_MOVEMENT_DATE = "/inventories/movements/search-date";
let inventoryItems = [];
let langDate = "es";
let inventory = [];

export const getStockByProduct = async (productQuantityListDto) => {
  return clientHttp.post(`${URL_STOCK_BY_PRODUCT}`, productQuantityListDto);
};

export const translateInventory = async (inventoryList) => {
  return clientHttp.post(`${URL_MOVEMENT_INVENTORY}`, inventoryList);
};

export const movementsByDate = async (dateInit, dateEnd) => {
  return (
    await clientHttp.get(
      `${URL_MOVEMENT_DATE}?dateInit=${dateInit}&dateEnd=${dateEnd}`,
    )
  ).data;
};

export const regularizeInventory = async (inventoryList) => {
  return clientHttp.post(`${URL}/regularize`, inventoryList);
};
